const Backbone = require('backbone');
var LeadTimeView = Backbone.View.extend({
	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.render);
		this.listenTo(Backbone, 'finish:hover', this.render);
	},

	el: '.js-lead-time',

	render: function(data) {
		this.$el.html(data.leadTimeMessage);
	}
});

module.exports = LeadTimeView;
